import { JDSDatepickerButtonProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSDatepickerButtonProps>
  ): React.FC<JDSDatepickerButtonProps> =>
  (props: JDSDatepickerButtonProps) => {
    return (
      <Component
        {...{
          ...props,
          _ariaExpanded: props.state === 'selected' ? 'true' : 'false'
        }}
      />
    );
  };
